import { motion } from 'framer-motion';
import { ClipboardCheck } from 'lucide-react';
import { Section } from '@/components/landing/Section';

export function Consultoria() {
  return (
    <Section id="consultoria">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.5 }}
        className="mx-auto max-w-3xl text-center"
      >
        <ClipboardCheck className="mx-auto h-10 w-10 text-primary" strokeWidth={1.5} aria-hidden />
        <h2 className="mt-4 text-3xl font-bold tracking-tight text-white lg:text-5xl">
          Consultoría en Seguridad
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-slate-400">
          Analizamos tus riesgos y diseñamos un plan de seguridad integral a la medida de tu
          operación. Auditorías, análisis de vulnerabilidades y protocolos que combinan personal y
          tecnología para una protección efectiva y medible.
        </p>
      </motion.div>
    </Section>
  );
}
